import RaisedButton from 'material-ui/RaisedButton';
import React from 'react'
import RunningGuy from './RunningGuy';
import UpdateButton from './../UpdateButton';

class HealthPluginUnavailable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={'container'}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
                    <div style={{ maxWidth: '90%', margin: '0 5%' }}>
                        <br /><RunningGuy />
                    </div>
                    <div style={{ padding: '0 25px 0 25px' }}>
                        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <span className={'activity-tracker-permissions-header'}>Track your steps and earn digital badges!</span>
                        </div>
                        <div style={{ textAlign: 'left', paddingTop: 10, paddingBottom: 10 }}>
                            <span className={'activity-tracker-permissions-description'}>This feature requires an update! Use the button below to get the latest version of the App.</span>
                        </div>
                        <UpdateButton />
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
            </div>
        )
    }
}

export default HealthPluginUnavailable;



// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/HealthPluginUnavailable.js